import type { IPascoRepository } from "@src/domain/pascos/repository/pasco_repository";
import type { PascoDTO } from "../dto";
import { PascoDtoMapper } from "../mappers/pasco-dto.mapper";

/**
 * Use Case: Approve PASCO
 * Approves a PASCO record for processing
 */
export class ApprovePascoUseCase {
    constructor(private readonly pascoRepository: IPascoRepository) { }

    /**
     * Execute the use case
     * @param pascoId - The unique identifier of the PASCO to approve
     * @returns Promise<PascoDTO> - The approved PASCO DTO
     * @throws Error if pascoId is invalid
     */
    async execute(pascoId: string): Promise<PascoDTO> {
        if (!pascoId || pascoId.trim() === '') {
            throw new Error('PASCO ID is required');
        }

        const pasco = await this.pascoRepository.approve(pascoId);
        return PascoDtoMapper.toDTO(pasco);
    }
}
